import { createAuthorizer } from "./authorizer-helper.js";

const authorizer = createAuthorizer();
export default authorizer;